import { render, staticRenderFns } from "./advertisement_putting.vue?vue&type=template&id=83fdc70a&scoped=true"
import script from "./advertisement_putting.vue?vue&type=script&lang=js"
export * from "./advertisement_putting.vue?vue&type=script&lang=js"
import style0 from "./advertisement_putting.vue?vue&type=style&index=0&id=83fdc70a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83fdc70a",
  null
  
)

export default component.exports